// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3R0ht","large":"styles_large__2_Yr_"};